import {
  Sheet,
  SheetContent,
  SheetTitle,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/sheet';
import { Skeleton } from '@art-of-hospitality-solutions-llc/ui-kit/components/skeleton';
import { useWeddingReport } from '@Hooks/useWeddingReports';

interface Props {
  reportId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function WeddingReportSheet({
  reportId,
  open,
  onOpenChange,
}: Props) {
  const { data: report, status } = useWeddingReport({
    id: reportId ?? undefined,
    enabled: open && !!reportId,
  });

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      {/* gap-0/p-0 remove the sheet's default header gap + padding so the
          embedded email sits flush against the top. */}
      <SheetContent className="flex w-full flex-col gap-0 p-0 sm:max-w-xl">
        {/* Accessibility title only; the embedded email carries its own header. */}
        <SheetTitle className="sr-only">Weddings Won</SheetTitle>
        {/* Container clips its own overflow so the single scrollbar belongs to
            the iframe, not the sheet. */}
        <div className="min-h-0 flex-1 overflow-hidden">
          {status === 'pending' ? (
            <div className="space-y-3 p-6">
              <Skeleton className="h-40 w-full" />
              <Skeleton className="h-40 w-full" />
            </div>
          ) : !report ? (
            <p className="p-6 text-sm text-zinc-500">Report not found.</p>
          ) : (
            // The exact HTML sent by email, rendered verbatim so the desk and
            // the emailed report can never drift. Pinned to full height; the
            // iframe owns the scroll.
            <iframe
              title="Wedding rollup report"
              srcDoc={report.emailHtml}
              sandbox=""
              className="h-full w-full border-0"
            />
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
